(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdella-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-verdella-product]').forEach((root) => {
    const mainImage = root.querySelector('[data-vdp-main-image]');
    const galleryCount = root.querySelector('[data-vdp-gallery-count]');
    const variantId = root.querySelector('[data-vdp-variant-id]');
    const price = root.querySelector('[data-vdp-price]');
    const addButton = root.querySelector('[data-vdp-add]');
    root.querySelectorAll('[data-vdp-thumbnail]').forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumbnail.dataset.imageSrc;
        mainImage.alt = thumbnail.dataset.imageAlt || '';
        root.querySelectorAll('[data-vdp-thumbnail]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
        if (galleryCount) galleryCount.textContent = `${index + 1} / ${root.querySelectorAll('[data-vdp-thumbnail]').length}`;
      });
    });
    root.querySelectorAll('[data-vdp-variant]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (variantId) variantId.value = radio.value;
        if (price) price.textContent = radio.dataset.price;
        root.querySelectorAll('[data-vdp-variant-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
        if (addButton) {
          const available = radio.dataset.available === 'true';
          addButton.disabled = !available;
          addButton.textContent = available ? `${addButton.dataset.addLabel} — ${radio.dataset.price}` : addButton.dataset.soldLabel;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
